import React, {useState} from "react";
import MyPagination from "../../MyPagination"
import MySortedTh, {SortType, onThClickHelper} from "../../MySortTh"
import { User } from "../../../Model/Model"

const PendingUsersTable = (props: any) => {
  const [theUsers, setTheUsers] = useState<User[]>()
  const [sortColumnName, setSortColumnName] = useState<string>("")
  const [sortType, setSortType] = useState<string>("")

  if(theUsers !== props.data)
  {
    setTheUsers(props.data as User[])
  }
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const changeCurrentPage = (p: number) =>{
    setCurrentPage(p)
  }

  const onPageSizeChange = (p: number) => {
    setPageSize(p)
    setCurrentPage(1)
  }

  const getDisplayUsers = () => {
    let theResult = Object.values(Object.assign({}, theUsers || []))
    if(sortColumnName)
    {
      if(sortType === SortType.DESC)
      {
        theResult = (theResult as any[]).sort((a, b) => (b[sortColumnName] || "").toString().localeCompare(a[sortColumnName] || ""))
      }
      else{
        theResult = (theResult as any[]).sort((a, b) => (a[sortColumnName] || "").toString().localeCompare(b[sortColumnName] || ""))
      }
    }

    if(totalCount !== theResult.length)
    {
      setTotalCount(theResult.length)
    }
    
    return theResult
  }

  const [totalCount, setTotalCount] = useState<number>()
  // const selectRow = {
  //   mode: 'checkbox',
  //   clickToSelect: true,
  //   onSelect: (row, isSelect, rowIndex, e) => {
  //     props.handleCheckbox(row,isSelect)
  //   },
  //   hideSelectAll: true
  // };

  const checkOnChange = (e: any, theUser: User) => {
    let checkedValue = e.target.checked
    props.handleCheckbox(theUser, checkedValue)
  }

  return (
    <>
    {(getDisplayUsers() && getDisplayUsers().length > 0) ?
    <div>
    <table className="dataListTbMainList">
      <thead>
        <tr>
          <th style={{width: "100px"}}></th>
          <MySortedTh
            CurrentSortName={sortColumnName}
            SortAble={true}
            SortColumnName={'displayName'}
            SortType={sortType}
            Title="Name"
            onThClick={() => onThClickHelper(sortColumnName, sortType, 'displayName', setSortColumnName, setSortType)}
                      />
          <MySortedTh
            CurrentSortName={sortColumnName}
            SortAble={true}
            SortColumnName={'title'}
            SortType={sortType}
            Title="Title"
            onThClick={() => onThClickHelper(sortColumnName, sortType, 'title', setSortColumnName, setSortType)}
          />
          <MySortedTh
            CurrentSortName={sortColumnName}
            SortAble={true}
            SortColumnName={'company'}
            SortType={sortType}
            Title="Company Name"
            onThClick={() => onThClickHelper(sortColumnName, sortType, 'company', setSortColumnName, setSortType)}
          />
          <MySortedTh
            CurrentSortName={sortColumnName}
            SortAble={true}
            SortColumnName={'email'}
            SortType={sortType}
            Title="Eemail"
            onThClick={() => onThClickHelper(sortColumnName, sortType, 'email', setSortColumnName, setSortType)}
          />
          <MySortedTh
            CurrentSortName={sortColumnName}
            SortAble={true}
            SortColumnName={'userType'}
            SortType={sortType}
            Title="User Type"
            onThClick={() => onThClickHelper(sortColumnName, sortType, 'userType', setSortColumnName, setSortType)}
          />
          <MySortedTh
            CurrentSortName={sortColumnName}
            SortAble={true}
            SortColumnName={'role'}
            SortType={sortType}
            Title="Account Type"
            onThClick={() => onThClickHelper(sortColumnName, sortType, 'role', setSortColumnName, setSortType)}
          />
          <MySortedTh
            CurrentSortName={sortColumnName}
            SortAble={true}
            SortColumnName={'role'}
            SortType={sortType}
            Title="Requested Client"
            onThClick={() => onThClickHelper(sortColumnName, sortType, 'desiredClient', setSortColumnName, setSortType)}
          />
          <th style={{width: "100px"}}>Edit</th>
        </tr>
      </thead>
      <tbody>
        {getDisplayUsers() && (getDisplayUsers() as User[]).slice((currentPage - 1) * pageSize, currentPage * pageSize) 
        && (getDisplayUsers() as User[]).slice((currentPage - 1) * pageSize, currentPage * pageSize).map((item: User) =>{
          return <tr key={item.id}>
          <td><input type="checkbox" onChange={(e) => checkOnChange(e, item)}></input></td>
          <td>{item.displayName}</td>
          <td>{item.title}</td>
          <td>{item.company}</td>
          <td>{item.email}</td>
          <td>{item.userType}</td>
          <td>{item.role}</td>
          <td>{item.desiredClient}</td>
          <td>
            <div>
              <button
                className="btn btn-primary"
                onClick={() => {
                  props.handleShow(item);
                }}
              >
                <i className="fas fa-edit"></i>
              </button>
            </div>
          </td>
        </tr>
        }) }
      </tbody>
    </table>
      {totalCount && <MyPagination totalCount={totalCount} onPageSizeChange={(p) => onPageSizeChange(p)} currentPage={currentPage}
      onClick={(p) => changeCurrentPage(p)}/>}
  </div>
  :
  <div>There is no result</div>
     }
      
    </>
  );
}

export default PendingUsersTable;
